import { MenuOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "../../assets/img";

const Navbar = () => {
  const [activeTab, setActiveTab] = useState(null)
  const location = useLocation();
  let navbar = document.querySelector('.navbar');
  const handleMenu = () => {
    navbar.classList.toggle('active');
  }
   useEffect(() => {
     if (location.pathname === '/') {
       setActiveTab('home');
     } else if (location.pathname === '/shirt') {
       setActiveTab('shirt');
     } else if (location.pathname === '/trouser') {
       setActiveTab('trouser');
     } else if (location.pathname === '/jacket') {
       setActiveTab('jacket');
     } else if (location.pathname === '/about') {
       setActiveTab('about');
     }else{
      setActiveTab(null);
     }
   }, [location]);

  return (
    <header className='user-header'>
      <div id='menu-bar' onClick={handleMenu}>
        <MenuOutlined />
      </div>

      <Link to={'/'} className='logo'>
        Hay<span>Style</span>
      </Link>

      <nav className='navbar'>
        <Link to={'/'} className='link'>
          <span
            className={activeTab === 'home' ? 'active' : ''}
            onClick={() => setActiveTab('home')}
          >
            home
          </span>
        </Link>
        <Link to={'/shirt'} className='link'>
          <span
            className={activeTab === 'shirt' ? 'active' : ''}
            onClick={() => setActiveTab('shirt')}
          >
            Kaos
          </span>
        </Link>
        <Link to={'/trouser'} className='link'>
          <span
            className={activeTab === 'trouser' ? 'active' : ''}
            onClick={() => setActiveTab('trouser')}
          >
            Celana
          </span>
        </Link>
        <Link to={'/jacket'} className='link'>
          <span
            className={activeTab === 'jacket' ? 'active' : ''}
            onClick={() => setActiveTab('jacket')}
          >
            Jaket
          </span>
        </Link>
        <Link to={'/about'} className='link'>
          <span
            className={activeTab === 'about' ? 'active' : ''}
            onClick={() => setActiveTab('about')}
          >
            Tentang Kami
          </span>
        </Link>
      </nav>

      <Link to={'/'} className='logo'>
        <img src={Logo} alt='Logo' width={40} height={40} />
      </Link>
    </header>
  );
}

export default Navbar;